import { withStyles } from '@material-ui/core/styles';

export default withStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    padding: 2,
    textAlign: 'left',
  },
  title: {
    textAlign: 'center',
    color: '#192542',
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 400,
    marginBottom: '0.875rem',
  },
  logo: {
    textAlign: 'center',
    width: '40%',
  },
  date: {
    opacity: 0.5,
    textAlign: 'right',
    fontSize: theme.typography.pxToRem(14),
  },
  details: {
    textAlign: 'center',
  },
  paper: {
    marginBottom: '10px',
    padding: '0.8rem',
    '&:hover': {
      opacity: 0.5,
    },
  },
  gridButton: {
    textAlign: 'center',
  },
  buttonLoad: {
    color: '#192542',
    fontWeight: 500,
    fontSize: 12,
    border: '1px solid #ddd',
    borderRadius: '4px',
    background: '#fff',
  },
  content: {
    padding: 24,
    borderRadius: '5px !important',
    // 'textAlign': 'center',
    '& img': {
      maxWidth: '100%',
      display: 'block',
      margin: '0 auto',
    },
  },
  buttonBF: {
    margin: theme.spacing(1),
    color: '#ffff',
    backgroundColor: '#009358',
    '&:hover': {
      backgroundColor: '#007A49',
    },
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  hearthIcon: {
    marginLeft: theme.spacing(1),
    color: 'red',
  },
  extendedIconRight: {
    marginLeft: theme.spacing(1),
  },
}));
